export default function (state = null, action) {
	switch (action.type) {
		case 'FETCH_ORDER_SUCCESS':
			return action.response	
		default:
			return state
	}
}
